import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '@shared/button/button.component';
import { ModalTemplateComponent } from '@shared/modals/modal-template/modal-template.component';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

@Component({
  selector: 'zbp-branded-reports-help-modal',
  imports: [ModalTemplateComponent, ButtonComponent],
  templateUrl: './branded-reports-help-modal.component.html',
  styleUrl: './branded-reports-help-modal.component.scss'
})
export class BrandedReportsHelpModalComponent {
  static iconName = zbpIconNames.question_mark;

  static open(ngbModal: NgbModal): NgbModalRef {
    const modalRef = ngbModal.open(
      BrandedReportsHelpModalComponent,
      {
        size: 'lg'
      }
    );
    return modalRef;
  }

  constructor(private activeModal: NgbActiveModal) { }

  closeModal() {
    this.activeModal.close();
  }
}
